import React from "react";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from "recharts";
import { BarChart3 } from "lucide-react";

// Module-scoped styling constants — avoid per-render allocation.
const GRID_STROKE = "#e5d9c9";
const AXIS_TICK_STYLE = { fontSize: 12, fill: "#6E7A75" };
const Y_AXIS_TICK_STYLE = { fontSize: 11, fill: "#6E7A75" };
const Y_TICKS = [0, 50, 100];
const Y_DOMAIN = [0, 100];
const BAR_MARGIN = { top: 10, right: 10, left: -10, bottom: 0 };
const BAR_RADIUS = [6, 6, 0, 0];
const TOOLTIP_STYLE = { borderRadius: 12, border: `1px solid ${GRID_STROKE}`, fontSize: 12 };
const LEGEND_STYLE = { fontSize: 12 };

/** Per-chapter reading & quiz mastery bars. */
export default function PerChapterMasteryBars({ data, isAr }) {
  const label = (name) => {
    if (name === "reading") return isAr ? "القراءة" : "Reading";
    return isAr ? "أفضل اختبار" : "Quiz best";
  };

  return (
    <div className="rounded-2xl bg-white border border-border p-5 lg:col-span-12" data-testid="per-chapter-card">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-semibold mb-3">
        <BarChart3 className="w-3.5 h-3.5 text-sage" />
        {isAr ? "إتقان كل فصل" : "Per-chapter mastery"}
      </div>
      <div style={{ width: "100%", height: 260 }}>
        <ResponsiveContainer>
          <BarChart data={data} margin={BAR_MARGIN} barCategoryGap={16}>
            <CartesianGrid strokeDasharray="3 4" stroke={GRID_STROKE} vertical={false} />
            <XAxis dataKey="name" tick={AXIS_TICK_STYLE} />
            <YAxis domain={Y_DOMAIN} ticks={Y_TICKS} tick={Y_AXIS_TICK_STYLE} unit="%" />
            <Tooltip
              formatter={(v, n) => [`${v}%`, label(n)]}
              labelFormatter={(l, payload) => payload?.[0]?.payload?.title || l}
              contentStyle={TOOLTIP_STYLE}
            />
            <Legend wrapperStyle={LEGEND_STYLE} formatter={label} />
            <Bar dataKey="reading" fill="#4A675C" radius={BAR_RADIUS} />
            <Bar dataKey="quiz" fill="#D97757" radius={BAR_RADIUS} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
